module.exports = __webpack_public_path__ + "static/alert-88bd65a1cf98194f9ef3b6ca222ce602.png";